import { Button } from '@pelckmans/business-components/components/button';
import { Dialog, ModalDialog } from '@pelckmans/business-components/components/dialog';
import { ReactNode, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ModalContext from '../../../contexts/ModalContext';
import MaterialModalHeader from './common/MaterialModalHeader';
import { Node } from '../_api/TableOfContentsApi';

type ImagePreviewModalProps = {
  id: string;
  downloadUrl?: string;
  downloadDisclaimer?: JSX.Element;
  node: Node;
  contentType: ReactNode;
  image: {
    src: string;
    alt: string;
  };
  name: string;
  info: ReactNode;
  tutorialId?: string;
};

export default function ImagePreviewModal({
  id,
  downloadUrl,
  downloadDisclaimer,
  node,
  contentType,
  image,
  name,
  info,
  tutorialId,
}: ImagePreviewModalProps) {
  const { t } = useTranslation();

  const { closeModal } = useContext(ModalContext);

  const handleDownload = () => {
    window.open(downloadUrl, '_blank');
  };

  return (
    <ModalDialog
      id={id}
      closeViaEscape={!tutorialId}
      closeOnClickOutside={!tutorialId}
      closeTitle={t('ACTIONS.CLOSE')}
      onClose={() => closeModal(id)}
      className="material-dialog"
      fullScreen
    >
      <MaterialModalHeader
        title={name}
        description={node.description}
        contentType={contentType}
        tutorialId={tutorialId}
      />
      <Dialog.Body>
        <div className="information">
          <p className="name">{name}</p>
          {info}
          {(downloadUrl || downloadDisclaimer) && (
            <>
              <hr />
              {downloadDisclaimer}
              {!downloadDisclaimer && downloadUrl && (
                <Button onClick={handleDownload} variant="primary">
                  <i className="bc-icon bc-icon-arrow-down bc-icon--left" />
                  <span>{t('ACTIONS.DOWNLOAD')}</span>
                </Button>
              )}
            </>
          )}
        </div>
        <div className="image">
          <img src={image.src} alt={image.alt} />
        </div>
      </Dialog.Body>
    </ModalDialog>
  );
}
